(ns io.daskul.tutorial.webapp.config
  (:require-macros [io.daskul.tutorial.webapp.config :refer [load-config]]))

(def ^:private compiled (load-config))

(defn- present
  "Runtime values arrive via envsubst, which renders an UNSET variable as an
   empty string rather than omitting the key. Blank therefore means 'not
   configured' and must fall through to the compiled default — otherwise a
   variable nobody set would blank out a working value."
  [v]
  (when-not (or (nil? v) (= "" v)) v))

(defn apply-runtime
  "Pure: overlay values from /config.js onto the compiled config (#546).

   Only values actually supplied override; blank or missing ones leave the
   build-time default alone. That is what lets one image be promoted across
   environments while an unset variable stays harmless.

   `environment` drives both the top-level value and the Sentry environment
   tag, which is how the aero profiles already had it — the two were always
   the same string."
  [compiled runtime]
  (let [api-url (present (:apiUrl runtime))
        dsn     (present (:sentryDsn runtime))
        env     (present (:environment runtime))
        clarity (present (:clarityProjectId runtime))]
    (cond-> compiled
      api-url (assoc :api-url api-url)
      dsn     (assoc-in [:sentry :dsn] dsn)
      clarity (assoc-in [:clarity :project-id] clarity)
      env     (-> (assoc :environment env)
                  (assoc-in [:sentry :environment] env)))))

(defn- runtime-config
  "Values injected by /config.js, or nil if it never loaded."
  []
  (when-let [c (.-APP_CONFIG js/globalThis)]
    (js->clj c :keywordize-keys true)))

(def config (apply-runtime compiled (runtime-config)))

(defn api-url []
  (:api-url config))

(defn sentry-config []
  (:sentry config))

(defn environment []
  (:environment config))

(defn production? []
  (= "production" (environment)))

(defn debug-enabled? []
  (get-in config [:features :enable-debug]))

(defn build-info []
  (:build config))

(defn version []
  (get-in config [:build :version]))

(defn git-sha []
  (get-in config [:build :git-sha]))
